// Shared i18n resources for the camera/wall app and the Cast/TV build.
const translationResources = {
    en: {
        translation: {}
    },
    nl: {
        translation: {
            "Tap open below to join.": "Klik hieronder om te joinen.",
            "Continue": "Doorgaan",
            "Join event": "Event joinen",
            "Please enter your full name to join this event.": "Vul je naam in om door te gaan.",
            "Full name": "Naam",
            "Tap here to open camera": "Klik hier om de camera te openen",
            "Tap here to open camera and take pictures for the album.": "Klik hier om de camera te openen en foto's te maken voor het album",
            "Failed to upload. Do you have an internet connection?": "Uploaden mislukt. Heb je een internet verbinding?",
            'Uploaded ✅': "Geupload ✅",
            'Uploading photo...': 'Aan het uploaden...',
            'You have no more photos left': "Je heb geen foto's meer over",
            "Receive album link": "Album bekijken",
            "enterMailReveal": "Vul je email adres in om een link naar het album te ontvangen zodra het op <1>{{reveal}}</1> onthult",
            "revealComeBack": "De foto's worden onthult op <1>{{reveal}}</1>. Kom dan terug.",
            "Otherwise we won't be able to send you a link to the album once it reveals!": "Anders kunnen we geen link versturen naar het album zodra het onthult.",
            "Enter your email address to receive a link to the album so you can easily access it in the future.": "Vul je email adres in om een link naar het album te ontvangen om gemakkelijk het album te bekijken in de toekomst.",
            "Notify me": "Stuur mail zodra het zover is!",
            "Email Address": "E-mail adres",
            "Looks like you already have an account": "Het lijkt erop dat je al een Lense account hebt.",
            "We have just emailed you a verification code. Please enter it down below.": "We hebben je zojuist een code gestuurd via de mail. Vul deze hieronder in",
            "Verification code": "Verificatiecode",
            "We have to verify your email to continue.": "We moeten je e-mail adres verifieren om door te gaan.",
            "Verify code": "Verifieer",
            "Upload your photos": "Foto's uploaden",
            "Filter effect": "Filter effect",
            "Everyone": "Iedereen",
            "Filter by guest": "Filter op gast",
            "The organizer of this event chose to hide other people's photos. You can only view your own photos.": "De organisator heeft ervoor gekozen om (voor nu) de foto's te verbergen. Je kan op dit moment enkel je eigen foto's bekijken.",
            "Live Photo Wall": "Live fotowand",
            "Cast to TV": "Stuur naar TV",
            "Board": "Bord",
            "Cinematic": "Cinematisch",
            "Scan to add your photo!": "Scan om je foto toe te voegen!",
            "Cast to your TV": "Stuur naar je TV",
            "Show the wall on any screen in seconds.": "Toon de wand op elk scherm in seconden.",
            "Open this page in Google Chrome on the computer connected to your TV or Chromecast.": "Open deze pagina in Google Chrome op de computer die verbonden is met je TV of Chromecast.",
            "Click the menu in the top-right corner and choose \"Cast\".": "Klik op het menu in de rechterbovenhoek en kies \"Casten\".",
            "Select your TV or Chromecast from the list.": "Selecteer je TV of Chromecast uit de lijst.",
            "Every guest's photo will appear live on your screen.": "Elke foto van je gasten verschijnt live op je scherm.",
            "Copy page link": "Paginalink kopiëren",
            "Link copied!": "Link gekopieerd!",
            "Welcome to the wall!": "Welkom op de wand!",
            "Everything you need to know.": "Alles wat je moet weten.",
            "Share the QR code": "Deel de QR-code",
            "Guests scan the code on screen and the camera opens instantly. No app needed.": "Gasten scannen de code op het scherm en de camera opent meteen. Geen app nodig.",
            "Photos appear live": "Foto's verschijnen live",
            "Every photo lands on the wall the moment it is taken.": "Elke foto verschijnt op de wand op het moment dat hij wordt gemaakt.",
            "Customise anytime": "Pas altijd aan",
            "Move your mouse to reveal the controls. Switch between Cinematic and Board mode, or open Settings.": "Beweeg je muis om de bedieningselementen te tonen. Schakel tussen Cinematisch en Bord modus, of open Instellingen.",
            "Got it, start the show!": "Begrepen, start de show!",
            "Customize": "Aanpassen",
            "Background": "Achtergrond",
            "Cork": "Kurk",
            "Dark": "Donker",
            "Light": "Licht",
            "Card size": "Kaartgrootte",
            "Small": "Klein",
            "Medium": "Gemiddeld",
            "Large": "Groot",
            "Rotation": "Rotatie",
            "Straight": "Recht",
            "Subtle": "Subtiel",
            "Wild": "Wild",
            "Content": "Inhoud",
            "Show captions": "Bijschriften tonen",
            "Show uploader names": "Uploadernamen tonen",
            "Show QR code": "QR-code tonen",
            "Slideshow speed": "Diavoorstelling snelheid",
            "Waiting for the first photo…": "Wachten op de eerste foto…"
        }
    },
    de: {
        translation: {
            "Tap open below to join.": "Tippe unten auf Öffnen, um beizutreten.",
            "Continue": "Weiter",
            "Join event": "Event beitreten",
            "Please enter your full name to join this event.": "Bitte gib deinen vollständigen Namen ein, um diesem Event beizutreten.",
            "Full name": "Vollständiger Name",
            "Tap here to open camera": "Tippe hier, um die Kamera zu öffnen",
            "Tap here to open camera and take pictures for the album.": "Tippe hier, um die Kamera zu öffnen und Fotos für das Album zu machen.",
            "Failed to upload. Do you have an internet connection?": "Upload fehlgeschlagen. Hast du eine Internetverbindung?",
            "Photo uploaded ✅": "Foto hochgeladen ✅",
            "Uploading photo...": "Foto wird hochgeladen...",
            "You have no more photos left": "Du hast keine Fotos mehr übrig",
            "Receive album link": "Album-Link erhalten",
            "enterMailReveal": "Gib deine E-Mail-Adresse ein, um einen Link zum Album zu erhalten, sobald es am <1>{{reveal}}</1> enthüllt wird.",
            "revealComeBack": "Die Fotos werden am <1>{{reveal}}</1> enthüllt. Komm dann zurück.",
            "Otherwise we won't be able to send you a link to the album once it reveals!": "Andernfalls können wir dir keinen Link zum Album senden, sobald es enthüllt wird.",
            "Enter your email address to receive a link to the album so you can easily access it in the future.": "Gib deine E-Mail-Adresse ein, um einen Link zum Album zu erhalten, damit du es in Zukunft leicht aufrufen kannst.",
            "Notify me": "Benachrichtige mich",
            "Email Address": "E-Mail-Adresse",
            "Looks like you already have an account": "Es sieht so aus, als hättest du bereits ein Lense-Konto.",
            "We have just emailed you a verification code. Please enter it down below.": "Wir haben dir gerade einen Bestätigungscode per E-Mail geschickt. Bitte gib ihn unten ein.",
            "Verification code": "Bestätigungscode",
            "We have to verify your email to continue.": "Wir müssen deine E-Mail-Adresse verifizieren, um fortzufahren.",
            "Verify code": "Code bestätigen",
            "Upload your photos": "Lade deine Fotos hoch",
            "Filter effect": "Filtereffekt",
            "Everyone": "Alle",
            "Filter by guest": "Nach Gast filtern",
            "The organizer of this event chose to hide other people's photos. You can only view your own photos.": "Der Veranstalter hat entschieden, die Fotos anderer zu verbergen. Du kannst nur deine eigenen Fotos sehen.",
            "Live Photo Wall": "Live-Fotowand",
            "Cast to TV": "Auf TV übertragen",
            "Board": "Pinnwand",
            "Cinematic": "Kinoformat",
            "Scan to add your photo!": "Scannen, um dein Foto hinzuzufügen!",
            "Cast to your TV": "Auf deinen Fernseher übertragen",
            "Show the wall on any screen in seconds.": "Zeige die Wand in Sekunden auf jedem Bildschirm.",
            "Open this page in Google Chrome on the computer connected to your TV or Chromecast.": "Öffne diese Seite in Google Chrome auf dem Computer, der mit deinem Fernseher oder Chromecast verbunden ist.",
            "Click the menu in the top-right corner and choose \"Cast\".": "Klicke auf das Menü in der oberen rechten Ecke und wähle „Übertragen\".",
            "Select your TV or Chromecast from the list.": "Wähle deinen Fernseher oder Chromecast aus der Liste.",
            "Every guest's photo will appear live on your screen.": "Jedes Gästefoto erscheint live auf deinem Bildschirm.",
            "Copy page link": "Seitenlink kopieren",
            "Link copied!": "Link kopiert!",
            "Welcome to the wall!": "Willkommen an der Wand!",
            "Everything you need to know.": "Alles was du wissen musst.",
            "Share the QR code": "QR-Code teilen",
            "Guests scan the code on screen and the camera opens instantly. No app needed.": "Gäste scannen den Code auf dem Bildschirm und die Kamera öffnet sich sofort. Keine App nötig.",
            "Photos appear live": "Fotos erscheinen live",
            "Every photo lands on the wall the moment it is taken.": "Jedes Foto erscheint auf der Wand in dem Moment, in dem es aufgenommen wird.",
            "Customise anytime": "Jederzeit anpassen",
            "Move your mouse to reveal the controls. Switch between Cinematic and Board mode, or open Settings.": "Bewege die Maus, um die Steuerung einzublenden. Wechsle zwischen Kinoformat- und Pinnwand-Modus oder öffne Einstellungen.",
            "Got it, start the show!": "Verstanden, zeig es mir!",
            "Customize": "Anpassen",
            "Background": "Hintergrund",
            "Cork": "Kork",
            "Dark": "Dunkel",
            "Light": "Hell",
            "Card size": "Kartengröße",
            "Small": "Klein",
            "Medium": "Mittel",
            "Large": "Groß",
            "Rotation": "Rotation",
            "Straight": "Gerade",
            "Subtle": "Subtil",
            "Wild": "Wild",
            "Content": "Inhalt",
            "Show captions": "Beschriftungen anzeigen",
            "Show uploader names": "Uploader-Namen anzeigen",
            "Show QR code": "QR-Code anzeigen",
            "Slideshow speed": "Diashow-Geschwindigkeit",
            "Waiting for the first photo…": "Warten auf das erste Foto…"
        }
    },
    es: {
        translation: {
            "Tap open below to join.": "Toca abrir abajo para unirte.",
            "Continue": "Continuar",
            "Join event": "Unirse al evento",
            "Please enter your full name to join this event.": "Por favor, introduce tu nombre completo para unirte a este evento.",
            "Full name": "Nombre completo",
            "Tap here to open camera": "Toca aquí para abrir la cámara",
            "Tap here to open camera and take pictures for the album.": "Toca aquí para abrir la cámara y tomar fotos para el álbum.",
            "Failed to upload photo. Do you have an internet connection?": "Error al subir. ¿Tienes conexión a internet?",
            "Photo uploaded ✅": "Foto subida ✅",
            "Uploading photo...": "Subiendo foto...",
            "You have no more photos left": "No te quedan más fotos",
            "Receive album link": "Recibir enlace del álbum",
            "enterMailReveal": "Introduce tu correo electrónico para recibir un enlace al álbum cuando se revele el <1>{{reveal}}</1>.",
            "revealComeBack": "Las fotos se revelarán el <1>{{reveal}}</1>. Vuelve entonces.",
            "Otherwise we won't be able to send you a link to the album once it reveals!": "De lo contrario, no podremos enviarte un enlace al álbum cuando se revele.",
            "Enter your email address to receive a link to the album so you can easily access it in the future.": "Introduce tu correo electrónico para recibir un enlace al álbum y acceder fácilmente en el futuro.",
            "Notify me": "Notificarme",
            "Email Address": "Correo electrónico",
            "Looks like you already have an account": "Parece que ya tienes una cuenta de Lense.",
            "We have just emailed you a verification code. Please enter it down below.": "Te hemos enviado un código de verificación por correo electrónico. Por favor, introdúcelo abajo.",
            "Verification code": "Código de verificación",
            "We have to verify your email to continue.": "Debemos verificar tu correo electrónico para continuar.",
            "Verify code": "Verificar código",
            "Upload your photos": "Sube tus fotos",
            "Filter effect": "Efecto de filtro",
            "Everyone": "Todos",
            "Filter by guest": "Filtrar por invitado",
            "The organizer of this event chose to hide other people's photos. You can only view your own photos.": "El organizador de este evento decidió ocultar las fotos de otras personas. Solo puedes ver tus propias fotos.",
            "Live Photo Wall": "Muro de fotos en vivo",
            "Cast to TV": "Enviar a TV",
            "Board": "Tablero",
            "Cinematic": "Cinematográfico",
            "Scan to add your photo!": "¡Escanea para añadir tu foto!",
            "Cast to your TV": "Enviar a tu TV",
            "Show the wall on any screen in seconds.": "Muestra el muro en cualquier pantalla en segundos.",
            "Open this page in Google Chrome on the computer connected to your TV or Chromecast.": "Abre esta página en Google Chrome en el ordenador conectado a tu TV o Chromecast.",
            "Click the menu in the top-right corner and choose \"Cast\".": "Haz clic en el menú en la esquina superior derecha y elige \"Emitir\".",
            "Select your TV or Chromecast from the list.": "Selecciona tu TV o Chromecast de la lista.",
            "Every guest's photo will appear live on your screen.": "La foto de cada invitado aparecerá en vivo en tu pantalla.",
            "Copy page link": "Copiar enlace de página",
            "Link copied!": "¡Enlace copiado!",
            "Welcome to the wall!": "¡Bienvenido al muro!",
            "Everything you need to know.": "Todo lo que necesitas saber.",
            "Share the QR code": "Compartir el código QR",
            "Guests scan the code on screen and the camera opens instantly. No app needed.": "Los invitados escanean el código en pantalla y la cámara se abre al instante. No se necesita app.",
            "Photos appear live": "Las fotos aparecen en vivo",
            "Every photo lands on the wall the moment it is taken.": "Cada foto aparece en el muro en el momento en que se toma.",
            "Customise anytime": "Personaliza en cualquier momento",
            "Move your mouse to reveal the controls. Switch between Cinematic and Board mode, or open Settings.": "Mueve el ratón para mostrar los controles. Cambia entre el modo Cinematográfico y Tablero, o abre Ajustes.",
            "Got it, start the show!": "¡Entendido, que empiece el espectáculo!",
            "Customize": "Personalizar",
            "Background": "Fondo",
            "Cork": "Corcho",
            "Dark": "Oscuro",
            "Light": "Claro",
            "Card size": "Tamaño de tarjeta",
            "Small": "Pequeño",
            "Medium": "Mediano",
            "Large": "Grande",
            "Rotation": "Rotación",
            "Straight": "Recto",
            "Subtle": "Sutil",
            "Wild": "Salvaje",
            "Content": "Contenido",
            "Show captions": "Mostrar leyendas",
            "Show uploader names": "Mostrar nombres de quienes suben",
            "Show QR code": "Mostrar código QR",
            "Slideshow speed": "Velocidad del pase de diapositivas",
            "Waiting for the first photo…": "Esperando la primera foto…"
        }
    }
};

export default translationResources;
